// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"MedicalHistory_gridContainer__3uDYO"};